const routes = [
    {
      path: '/perimeter',
      name: 'perimeter',
      component: () => import('./view/Index.vue'),
      meta: {
        requireAuth: false
      }
    }
  ]
  
  export default routes